import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import { OWNERSHIP_STATUS, getOwnershipStatus } from '../../../utils/llmUtils';
import { Tooltip } from '@material-ui/core';

const ICON_FILTERS = {
    manual: 'brightness(0) saturate(100%) invert(27%) sepia(4%) saturate(478%) hue-rotate(23deg) brightness(94%) contrast(89%)',
    // targets #444441 (dark gray)
    aiGenerated: 'brightness(0) saturate(100%) invert(20%) sepia(60%) saturate(800%) hue-rotate(220deg) brightness(80%)',
    // targets #3C3489 (purple)
    customized: 'brightness(0) saturate(100%) invert(19%) sepia(97%) saturate(1665%) hue-rotate(15deg) brightness(94%) contrast(105%)',
    // targets #633806 (brown)
    aiEnhanced: 'brightness(0) saturate(100%) invert(25%) sepia(40%) saturate(600%) hue-rotate(70deg) brightness(70%)',
    // targets #27500A (green)
};

const AI_ICON = (colorKey) => (
    <img
        width="13"
        height="13"
        src={`${process.env.PUBLIC_URL}/ide_icons/ai.svg`}
        alt=""
        style={{
            marginLeft: 6,
            marginTop: 1,
            filter: ICON_FILTERS[colorKey],
        }}
    />
);

const USER_ICON = (colorKey) => (
    <img
        width="13"
        height="13"
        src={`${process.env.PUBLIC_URL}/ide_icons/user_outline.svg`}
        alt=""
        style={{
            marginLeft: 6,
            filter: ICON_FILTERS[colorKey]
        }}
    />
);




const STATUS_CONFIG = {
    [OWNERSHIP_STATUS.AI_GENERATED]: {
        label: 'AI Generated',
        Icon: AI_ICON('aiGenerated'),
        colorKey: 'aiGenerated',
        tooltip: "Generated by AI"
    },
    [OWNERSHIP_STATUS.AI_UPDATED]: {
        label: 'AI Enhanced',
        Icon: AI_ICON('aiEnhanced'),
        colorKey: 'aiEnhanced',
        tooltip: "Manually created and later updated by AI"
    },
};

const useStyles = makeStyles({
    chip: {
        height: 20,
        fontSize: 11,
        fontWeight: 500,
        borderRadius: 10,
        border: '1.5px solid transparent',
    },
    icon: {
        fontSize: '13px !important',
        marginLeft: '6px !important',
        marginRight: '-4px !important',
        width: '16px !important',
        height: '16px !important',
    },
    manual: {
        backgroundColor: '#F1EFE8',
        color: '#444441 !important',
        borderColor: '#B4B2A9',
        '& $icon': { color: '#444441' },
    },
    aiGenerated: {
        backgroundColor: '#EEEDFE',
        color: '#3C3489 !important',
        borderColor: '#AFA9EC',
        '& $icon': { color: '#3C3489' },
    },
    customized: {
        backgroundColor: '#FAEEDA',
        color: '#633806 !important',
        borderColor: '#EF9F27',
        '& $icon': { color: '#633806' },
    },
    aiEnhanced: {
        backgroundColor: '#EAF3DE',
        color: '#27500A !important',
        borderColor: '#97C459',
        '& $icon': { color: '#27500A' },
    },
});



const OwnershipStatusLabel = ({ entity, style = {} }) => {
    const classes = useStyles();
    if (!entity?.provenance) return null;

    const status = getOwnershipStatus(entity.provenance);

    if (!status) return null;

    const { label, Icon, colorKey, tooltip } = STATUS_CONFIG[status];

    return (
        <Tooltip
            title={tooltip}
            arrow
        >
            <Chip
                size="small"
                label={label}
                icon={Icon || undefined}
                classes={{ icon: classes.icon }}
                className={`${classes.chip} ${classes[colorKey]}`}
                style={{ ...style }}
            />
        </Tooltip>
    );
};

export default OwnershipStatusLabel;